import { checkEnvironment } from '@saviynt/common';

const getSshAccessKeysApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/ssh-keys`;
};

export default getSshAccessKeysApiUrl;
